import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Divider,
  TextField,
  MenuItem,
} from "@mui/material";
import { API_URL } from "../../../Config/api";

function StepTwoDiagnosisForm({ formData, setFormData, errors, handleChange }) {
  // const port = process.env.REACT_APP_API_KEY;
  const accessToken = localStorage.getItem("token");
  const [referHospital, setReferHospital] = useState([]);
  const [consultantList, setConsultantList] = useState([]);
  const [selectedHospital, setSelectedHospital] = useState("");
  const [durationDays, setDurationDays] = useState("");
  const [selectedConsultantId, setSelectedConsultantId] = useState("");

  useEffect(() => {
    const getreferHospital = async () => {
      try {
        const res = await fetch(`${API_URL}/web/agg_hhc_hospitals_api_web_form`, {
          headers: {
            // Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        });
        const data = await res.json();
        // console.log("Refer Hospital data", data);
        setReferHospital(data);
      } catch (error) {
        console.error("Error fetching Refer Hospital data:", error);
      }
    };
    getreferHospital();
  }, []);

  const getConsultant = async () => {
    try {
      const res = await fetch(`${API_URL}/web/agg_hhc_consultant_HD_api_long_term/`, {
        headers: {
          // Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      setConsultantList(data);
    } catch (error) {
      console.error("Error fetching Consultant data:", error);
    }
  };

  useEffect(() => {
    getConsultant();
  }, [API_URL, accessToken]);

  useEffect(() => {
    const { hospitalization_from, hospitalization_to } = formData;

    if (hospitalization_from && hospitalization_to) {
      const fromDate = new Date(hospitalization_from);
      const toDate = new Date(hospitalization_to);

      if (toDate >= fromDate) {
        const diffTime = toDate.getTime() - fromDate.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
        setDurationDays(diffDays);
      } else {
        setDurationDays("");
      }
    } else {
      setDurationDays("");
    }
  }, [formData.hospitalization_from, formData.hospitalization_to]);

  const handleConsultantChange = (e) => {
    const selectedId = e.target.value;
    setSelectedConsultantId(selectedId);

    // ✅ 1. Save CONSULTANT ID in formData
    handleChange("primary_consultant_name", selectedId);

    // ✅ 2. Auto-fill phone number
    const selectedConsultant = consultantList.find(
      (c) => c.doct_cons_id === selectedId
    );

    if (selectedConsultant) {
      handleChange(
        "primary_Consultant_Phone",
        selectedConsultant.mobile_no?.toString() || ""
      );
    }
  };

  useEffect(() => {
    if (formData.primary_consultant_name) {
      setSelectedConsultantId(formData.primary_consultant_name);
    }
  }, [formData.primary_consultant_name]);

  useEffect(() => {
    if (!selectedConsultantId || !consultantList.length) return;

    const consultant = consultantList.find(
      (c) => c.doct_cons_id === selectedConsultantId
    );

    if (consultant) {
      handleChange(
        "primary_Consultant_Phone",
        consultant.mobile_no?.toString() || ""
      );
    }
  }, [selectedConsultantId, consultantList]);

useEffect(() => {
  if (!referHospital.length || !formData.hosp_id) return;

  const hospitalId = Number(formData.hosp_id);

  const exists = referHospital.some(
    (h) => Number(h.hosp_id) === hospitalId
  );

  if (exists) {
    setSelectedHospital(hospitalId);
  }
}, [formData.hosp_id, referHospital]); 

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return dateStr.split("T")[0]; // "2025-12-01T00:00:00" -> "2025-12-01"
  };

  return (
    <Box>
      <Grid container spacing={2}>
        {/* CARD 1 - DIAGNOSIS */}
        <Grid item xs={12}>
          <Card
            variant="outlined"
            sx={{
              borderRadius: 3,
              boxShadow: 3,
              backgroundColor: "#fafafa",
              height: "100%",
            }}
          >
            <CardContent>
              <Typography
                gutterBottom
                color="primary"
                sx={{ fontWeight: "600", fontSize: "1rem" }}
              >
                DIAGNOSIS / MEDICAL CONDITION
              </Typography>

              <Divider sx={{ mb: 2 }} />

              <Grid container spacing={2}>
                {/* Diagnosis */}
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Diagnosis / Medical Condition"
                    fullWidth
                    size="small"
                    value={formData.diagnosis}
                    onChange={(e) => handleChange("diagnosis", e.target.value)}
                    error={!!errors.diagnosis}
                    helperText={errors.diagnosis}
                  />
                </Grid>

                {/* Hospital */}
                <Grid item xs={12} sm={6} md={3}>
  <TextField
    select
    label="Hospital"
    fullWidth
    size="small"
    value={selectedHospital ?? ""}
    onChange={(e) => {
      const value = Number(e.target.value);
      setSelectedHospital(value);
      setFormData((prev) => ({
        ...prev,
        hosp_id: value,
      }));
    }}
  >
    <MenuItem value="" disabled>
      Select Hospital
    </MenuItem>

    {referHospital.map((hospital) => (
      <MenuItem
        key={hospital.hosp_id}
        value={Number(hospital.hosp_id)}
      >
        {hospital.hospital_name}
      </MenuItem>
    ))}
  </TextField>
</Grid>


                {/* Primary Consultant */}
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    select
                    label="Primary Consultant"
                    fullWidth
                    size="small"
                    value={selectedConsultantId}
                    onChange={handleConsultantChange}
                    error={!!errors.primary_consultant_name}
                    helperText={errors.primary_consultant_name}
                  >
                    {consultantList.map((c) => (
                      <MenuItem key={c.doct_cons_id} value={c.doct_cons_id}>
                        {c.cons_fullname}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {/* Phone */}
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Primary Consultant Phone"
                    fullWidth
                    size="small"
                    value={formData.primary_Consultant_Phone || ""}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        handleChange("primary_Consultant_Phone", value);
                      }
                    }}
                    error={!!errors.primary_Consultant_Phone}
                    helperText={errors.primary_Consultant_Phone}
                    inputProps={{
                      maxLength: 10,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                        readOnly: true,
                    }}
                  />
                </Grid>

                {/* Email */}
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Primary Consultant Email"
                    fullWidth
                    size="small"
                    value={formData.primary_consultant_email}
                    onChange={(e) =>
                      handleChange("primary_consultant_email", e.target.value)
                    }
                    error={!!errors.primary_consultant_email}
                    helperText={errors.primary_consultant_email}
                  />
                </Grid>

                {/* Other Consultant */}
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Other Consultant"
                    fullWidth
                    size="small"
                    value={formData.other_consultant_name}
                    onChange={(e) =>
                      handleChange("other_consultant_name", e.target.value)
                    }
                    error={!!errors.other_consultant_name}
                    helperText={errors.other_consultant_name}
                  />
                </Grid>

                {/* Other Phone */}
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Other Consultant Phone"
                    fullWidth
                    size="small"
                    value={formData.other_consultant_phone}
                    onChange={(e) => {
                      let value = e.target.value.replace(/\D/g, "");
                      if (value.length > 10) value = value.slice(0, 10);
                      handleChange("other_consultant_phone", value);
                    }}
                    inputProps={{
                      maxLength: 10,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    }}
                    error={!!errors.other_consultant_phone}
                    helperText={errors.other_consultant_phone}
                  />
                </Grid>

                {/* Other Email */}
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Other Consultant Email"
                    fullWidth
                    size="small"
                    value={formData.other_consultant_email}
                    onChange={(e) =>
                      handleChange("other_consultant_email", e.target.value)
                    }
                    error={!!errors.other_consultant_email}
                    helperText={errors.other_consultant_email}
                  />
                </Grid>

                {/* Duration From */}
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Duration From"
                    type="date"
                    size="small"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={formatDate(formData.hospitalization_from)}
                    onChange={(e) =>
                      handleChange("hospitalization_from", e.target.value)
                    }
                    error={!!errors.hospitalization_from}
                    helperText={errors.hospitalization_from}
                  />
                </Grid>

                {/* Duration To */}
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Duration To"
                    type="date"
                    size="small"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={formatDate(formData.hospitalization_to)}
                    onChange={(e) =>
                      handleChange("hospitalization_to", e.target.value)
                    }
                    inputProps={{
                      max: new Date().toISOString().split("T")[0], // blocks future dates
                    }}
                    error={!!errors.hospitalization_to}
                    helperText={errors.hospitalization_to}
                  />
                </Grid>

                {/* Total Days */}
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Total Days"
                    fullWidth
                    size="small"
                    value={durationDays}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* CARD 2 */}
        <Grid item xs={12}>
          <Card
            variant="outlined"
            sx={{
              borderRadius: 3,
              boxShadow: 3,
              backgroundColor: "#fafafa",
            }}
          >
            <CardContent>
              <Typography
                gutterBottom
                color="primary"
                sx={{ fontWeight: "600", fontSize: "1rem" }}
              >
                CURRENT TREATMENT PLAN
              </Typography>

              <Divider sx={{ mb: 2 }} />

              <Grid container spacing={2}>
                {/* Tablet */}
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label="Tablet"
                    size="small"
                    multiline
                    minRows={3}
                    fullWidth
                    value={formData.ctp_tablet}
                    onChange={(e) => handleChange("ctp_tablet", e.target.value)}
                    error={!!errors.ctp_tablet}
                    helperText={errors.ctp_tablet}
                  />
                </Grid>

                {/* Injections */}
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label="Injections"
                    size="small"
                    multiline
                    minRows={3}
                    fullWidth
                    value={formData.ctp_injection}
                    onChange={(e) =>
                      handleChange("ctp_injection", e.target.value)
                    }
                    error={!!errors.ctp_injection}
                    helperText={errors.ctp_injection}
                  />
                </Grid>

                {/* IV Fluids */}
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label="IV Fluids"
                    size="small"
                    multiline
                    minRows={3}
                    fullWidth
                    value={formData.ctp_iv_fluids}
                    onChange={(e) =>
                      handleChange("ctp_iv_fluids", e.target.value)
                    }
                    error={!!errors.ctp_iv_fluids}
                    helperText={errors.ctp_iv_fluids}
                  />
                </Grid>

                {/* Interventions */}
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    label="Interventions"
                    size="small"
                    multiline
                    minRows={3}
                    fullWidth
                    value={formData.ctp_interventions}
                    onChange={(e) =>
                      handleChange("ctp_interventions", e.target.value)
                    }
                    error={!!errors.ctp_interventions}
                    helperText={errors.ctp_interventions}
                  />
                </Grid>

                {/* Notes */}
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    label="Notes"
                    size="small"
                    multiline
                    minRows={3}
                    fullWidth
                    value={formData.ctp_notes}
                    onChange={(e) => handleChange("ctp_notes", e.target.value)}
                    error={!!errors.ctp_notes}
                    helperText={errors.ctp_notes}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* CARD 3 */}
        <Grid item xs={12}>
          <Card
            variant="outlined"
            sx={{
              borderRadius: 3,
              boxShadow: 3,
              backgroundColor: "#fafafa",
            }}
          >
            <CardContent>
              <Typography
                gutterBottom
                color="primary"
                sx={{ fontWeight: "600", fontSize: "1rem" }}
              >
                FOLLOW UP INSTRUCTIONS
              </Typography>

              <Divider sx={{ mb: 2 }} />

              <Grid container spacing={2}>
                {/* Physical */}
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    label="Physical"
                    size="small"
                    multiline
                    minRows={3}
                    fullWidth
                    value={formData.fi_physical}
                    onChange={(e) =>
                      handleChange("fi_physical", e.target.value)
                    }
                    error={!!errors.fi_physical}
                    helperText={errors.fi_physical}
                  />
                </Grid>

                {/* Investigation */}
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    label="Investigation"
                    size="small"
                    multiline
                    minRows={3}
                    fullWidth
                    value={formData.fi_investigations}
                    onChange={(e) =>
                      handleChange("fi_investigations", e.target.value)
                    }
                    error={!!errors.fi_investigations}
                    helperText={errors.fi_investigations}
                  />
                </Grid>

                {/* Interventions */}
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    label="Interventions"
                    size="small"
                    multiline
                    minRows={3}
                    fullWidth
                    value={formData.fi_interventions}
                    onChange={(e) =>
                      handleChange("fi_interventions", e.target.value)
                    }
                    error={!!errors.fi_interventions}
                    helperText={errors.fi_interventions}
                  />
                </Grid>

                {/* Assistance */}
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    label="Assistance"
                    size="small"
                    multiline
                    minRows={3}
                    fullWidth
                    value={formData.fi_assistance}
                    onChange={(e) =>
                      handleChange("fi_assistance", e.target.value)
                    }
                    error={!!errors.fi_assistance}
                    helperText={errors.fi_assistance}
                  />
                </Grid>

                {/* Referred By */}
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label="Referred By"
                    size="small"
                    fullWidth
                    value={formData.reffered_by}
                    onChange={(e) =>
                      handleChange("reffered_by", e.target.value)
                    }
                    error={!!errors.reffered_by}
                    helperText={errors.reffered_by}
                  />
                </Grid>

                {/* Phone */}
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label="Phone Number"
                    size="small"
                    fullWidth
                    value={formData.reffered_by_phone}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, ""); // remove non-numbers
                      if (value.length <= 10) {
                        handleChange("reffered_by_phone", value);
                      }
                    }}
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      maxLength: 10,
                    }}
                    error={!!errors.reffered_by_phone}
                    helperText={errors.reffered_by_phone}
                  />
                </Grid>

                {/* Email */}
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label="Email"
                    size="small"
                    fullWidth
                    value={formData.reffered_by_email}
                    onChange={(e) =>
                      handleChange("reffered_by_email", e.target.value)
                    }
                    error={!!errors.reffered_by_email}
                    helperText={errors.reffered_by_email}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

export default StepTwoDiagnosisForm;
